import { Injectable, WritableSignal, signal } from '@angular/core';
import {
  INotification,
  NotificationSystemService,
} from 'src/app/common-components/services/common-notification-system.service';
import {
  ProviderDirectoryFunctionService,
  WorkPreference,
} from 'src/app/services/providerdirectoryapi/providerdirectoryfunctionapi.services';

@Injectable({
  providedIn: 'root',
})
export class WorkPreferencesService {
  private _entity: WritableSignal<WorkPreference[]> = signal<WorkPreference[]>([]);
  private _load: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private searchService: ProviderDirectoryFunctionService,
    private notificationSystemService: NotificationSystemService
  ) {}

  async search() {
    this._load.set(true);
    this.searchService.getAllWorkPreferences().subscribe({
      next: res => {
        if (res) {
          this._entity.set(res.data);
        }
        this._load.set(false);
      },
      error: error => {
        this._load.set(false);
        if (error.message) {
          const notification: INotification = { type: 'error', content: error.message };
          this.notificationSystemService.setNotification(notification);
        }
      },
    });
  }

  public fetchData() {
    if (this._entity().length === 0) {
      this.search();
    }
  }

  getWorkPreferencesSignal(): WritableSignal<WorkPreference[]> {
    return this._entity;
  }

  public getLoad(): WritableSignal<boolean> {
    return this._load;
  }
}
